export const VCheckboxConfig = {
  color: 'primary',
};
